import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/items/home/global'

export const ITEMS_HOME_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
